
const getData = state => (data) => {
  return state[data]
}

export default {
  getData
}
